export default {
  default: () => import("/home/runner/work/app/app/src/layouts/default.vue").then(m => m.default || m),
  full: () => import("/home/runner/work/app/app/src/layouts/full.vue").then(m => m.default || m),
  plain: () => import("/home/runner/work/app/app/src/layouts/plain.vue").then(m => m.default || m)
}